/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import TListItem, { ListItemAnalytics, ListItemProp } from './ListItem';

/**
 * UI Toolkit component based on Veneer ListItem
 * @public
 */
const ListItem = ({
  item,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onHover,
  selectedIndex,
  index,
  dividerColor,
  id,
  ...rest
}: ListItemProp) => {
  if (item.trackId) {
    return (
      <ListItemAnalytics
        key={index}
        id={id}
        item={item}
        index={index}
        selectedIndex={selectedIndex}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onHover={onHover}
        trackId={item.trackId}
        canReturnParams={item.canReturnParams}
        stopTracking={item.stopTracking}
        trackCategory={item.trackCategory}
        trackedHandlers={item.trackedHandlers}
        untrackedHandlers={item.untrackedHandlers}
        dividerColor={dividerColor}
        {...rest}
      />
    );
  }
  return (
    <TListItem
      key={index}
      id={id}
      item={item}
      index={index}
      selectedIndex={selectedIndex}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onHover={onHover}
      dividerColor={dividerColor}
    />
  );
};

export default memo(ListItem);
